import { useContext, useMemo } from 'react';

import timeEntryStatusApproved from '@atom/components/common/svgIcons/timeEntryStatusApproved.svg';
import timeEntryStatusPending from '@atom/components/common/svgIcons/timeEntryStatusPending.svg';
import timeEntryStatusRejected from '@atom/components/common/svgIcons/timeEntryStatusRejected.svg';
import { AssetRequestStatus } from '@atom/types/assetRequest';
import { getDisplayDateTime } from '@atom/utilities/timeUtilities';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import ViewRequestContext from '../ViewRequestContext';

import classes from './ardotView.module.css';

const ReviewStatus = () => {
  const { activeRequest } = useContext(ViewRequestContext);

  const content = useMemo(() => {
    const statusText = `${activeRequest?.reviewBy?.firstName} ${
      activeRequest?.reviewBy?.lastName
    } on ${getDisplayDateTime(activeRequest?.reviewDate)}`;

    switch (true) {
      case activeRequest?.status === AssetRequestStatus.PENDING_REVIEW: {
        return (
          <div className={classes.statusContainer}>
            <img src={timeEntryStatusPending} />
            <div className={classes.statusText}>Waiting for Approval</div>
          </div>
        );
      }
      case activeRequest?.status === AssetRequestStatus.CANCELED &&
        !isNilOrEmpty(activeRequest?.reviewDate):
      case activeRequest?.status === AssetRequestStatus.REJECTED &&
        !isNilOrEmpty(activeRequest?.receiveDate):
      case activeRequest?.status === AssetRequestStatus.PENDING_APPROVAL:
      case activeRequest?.status === AssetRequestStatus.APPROVED: {
        return (
          <div className={classes.statusContainer}>
            <img src={timeEntryStatusApproved} />
            <div
              className={classes.statusText}
            >{`Approved by ${statusText}`}</div>
          </div>
        );
      }
      case activeRequest?.status === AssetRequestStatus.REJECTED &&
        isNilOrEmpty(activeRequest?.receiveDate): {
        return (
          <div className={classes.statusContainer}>
            <img src={timeEntryStatusRejected} />
            <div
              className={classes.statusText}
            >{`Rejected by ${statusText}`}</div>
          </div>
        );
      }
      case activeRequest?.status === AssetRequestStatus.CANCELED &&
        isNilOrEmpty(activeRequest?.reviewDate): {
        return <div />;
      }
      default:
        return <div />;
    }
  }, [activeRequest]);

  return <div>{content}</div>;
};

export default ReviewStatus;
